import styled from 'styled-components';

export const Wrapper = styled.div`
	top: 150px;
	margin-top: 50px;
	position: sticky;
	width: 250px;
	border-radius: 15px;
	background-color: #fff;
	border: 2px solid #0083c8;
	box-shadow: 0 0 20px #0000001c;
`;

export const TitleFont = styled.p`
	font-size: 17px;
	margin: 10px auto;
	text-align: center;
	color: #0083c8;
	font-weight: 600;
`;

export const SummaryContainer = styled.div`
	background-color: #0083c8;
	display: flex;
	justify-content: space-between;
	padding: 10px 20px;
	align-items: center;
	border-radius: 0 0 10px 10px;
	p:nth-child(1) {
		margin: 0;
		color: #f1f1f1;
		font-size: 14px;
	}
	p:nth-child(2) {
		margin: 0;
		color: #fff;
		font-size: 21px;
		font-weight: 600;
	}
`;

export const ItemsContainer = styled.div`
	width: 100%;
	display: flex;
	flex-flow: column nowrap;
	margin-top: 10px;
`;

export const ItemContainer = styled.div`
	display: flex;
	flex-flow: column;
	margin: 10px 15px;
	border-bottom: 1px solid #e6e6e6;
	& > p {
		margin: 0;
		color: #828282;
	}
`;

export const ItemDetailsContainer = styled.div`
	display: flex;
	justify-content: space-between;
	p {
		margin: 0;
		font-weight: 600;
		font-size: 14px;
	}
`;

export const ItemTitleFont = styled.div`
	margin: 0;
	color: #4e4e4e;
	font-size: 15px;
	max-width: 95%;
`;
